import React, { Component } from "react";
import { connect } from "react-redux";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
} from "reactstrap";

import {
  getTaxs,
  TaxAdd,
  TaxEdit,
  TaxDelete,
  model_open,
  model_close,
} from "../../../store/Masters/Taxs/actions";

class AddTaxs extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  handleValidSubmit(event, values) {
    this.props.TaxAdd(values, this.props.history);
  }
  render() {
    var data = this.props.rowdata;
    return (
      <React.Fragment>
        <Modal isOpen={this.props.model} backdrop="static" centered size="lg">
          <ModalHeader toggle={() => this.props.model_close()}>
            Add Tax
          </ModalHeader>
          <AvForm
            className="form-horizontal"
            onValidSubmit={this.handleValidSubmit}
          >
            <ModalBody>
              <Row className="justify-content-center">
                <Col md={10}>
                  <Row className="justify-content-center">
                    <Col md={9}>
                      <FormGroup row>
                        <Col md={4}>
                          <Label
                            htmlFor="TaxName"
                            className="col-form-label float-right"
                          >
                            Tax Name
                          </Label>
                        </Col>
                        <Col md={8}>
                          <AvField
                            name="name"
                            type="text"
                            value={data.name}
                            className="form-control"
                            id="TaxName"
                            placeholder="Enter Tax Name"
                            errormessage=" Please provide a valid Tax Name"
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Col md={4}>
                          <Label
                            htmlFor="TaxValue"
                            className="col-form-label float-right"
                          >
                            Tax Value
                          </Label>
                        </Col>
                        <Col md={8}>
                          <AvField
                            name="tax"
                            type="text"
                            value={data.tax}
                            className="form-control"
                            id="TaxValue"
                            placeholder="Enter Tax Value"
                            errormessage=" Please provide a valid Tax Value"
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup>
                        <AvField
                          className="form-control"
                          type="hidden"
                          value={data.id}
                          id="id"
                          name="id"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <ModalFooter>
                <Button
                  type="button"
                  className="btn btn-danger"
                  color="light"
                  onClick={() => this.props.model_close()}
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  className="btn btn-primary"
                  color="primary"
                >
                  Save
                </Button>
              </ModalFooter>
            </ModalBody>
          </AvForm>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const {  model, rowdata } = state.Tax;
  return {  model, rowdata };
};

export default connect(mapStatetoProps, {
  getTaxs,
  TaxAdd,
  TaxEdit,
  TaxDelete,
  model_open,
  model_close,
})(AddTaxs);
